import addressesCommitTypes from './commit-types';

const addressesActionsCreators = {
  addAddress() {
    return {
      isAddingAddress: true,
      type: addressesCommitTypes.SET_IS_ADDING_ADDRESS,
    };
  },
  closeAddAddress() {
    return {
      isAddingAddress: false,
      type: addressesCommitTypes.SET_IS_ADDING_ADDRESS,
    };
  },
  closeEditAddress() {
    return {
      isEditingAddress: -1,
      type: addressesCommitTypes.SET_IS_EDITING_ADDRESS,
    };
  },
  editAddress(index) {
    return {
      isEditingAddress: index,
      type: addressesCommitTypes.SET_IS_EDITING_ADDRESS,
    };
  },
  resetAddressState() {
    return {
      type: addressesCommitTypes.RESET_ADDRESS_STATE,
    };
  },
};

export default addressesActionsCreators;
